<template>
  <div class="pa-0 ma-0">
    <div>
      <div class="py-4 px-10">
        <v-row no-gutters>
          <v-col align="left" class="my-auto" cols="4">
            <v-sheet>
              <h3 class="text--black" style="font-size: 15px; font-weight: 500">
                Tanggal Unggah
              </h3>
            </v-sheet>
          </v-col>
          <v-col align="left" class="my-auto" cols="4">
            <v-sheet>
              <h3 class="text--black" style="font-size: 15px; font-weight: 500">
                Bulan Rekonsiliasi
              </h3>
            </v-sheet>
          </v-col>
          <v-col align="left" class="my-auto" cols="4">
            <v-sheet>
              <h3 class="text--black" style="font-size: 15px; font-weight: 500">
                Document
              </h3>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>

      <!-- Jika documents kosong -->
      <v-snackbar v-model="snackbar" :timeout="3000" shaped top color="white">
        {{ message }}
        <template v-slot:action="{ attrs }">
          <v-btn color="#004643" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <div
        v-if="documents.length === 0"
        class="d-flex justify-center align-center"
        style="height: 60vh"
      >
        <h3 class="text--grey" style="font-size: 14px; font-weight: 400">
          Tidak ada dokumen tersedia.
        </h3>
      </div>

      <!-- Jika documents tidak kosong -->
      <div v-else class="px-10">
        <template v-for="(item, index) in documents">
          <v-row no-gutters :key="index" class="py-5">
            <v-col align="left" class="my-auto" cols="4">
              <v-sheet>
                <div class="d-flex align-center">
                  <v-icon class="mr-4" style="color: #004643"
                    >mdi-clock-outline
                  </v-icon>
                  <h3
                    class="text--black"
                    style="font-size: 14px; font-weight: 400"
                  >
                    {{ item.created_at }}
                  </h3>
                </div>
              </v-sheet>
            </v-col>
            <v-col align="left" class="my-auto" cols="4">
              <v-sheet>
                <div class="d-flex align-center">
                  <v-icon class="mr-4" style="color: #004643"
                    >mdi-clock-outline
                  </v-icon>
                  <h3
                    class="text--black"
                    style="font-size: 14px; font-weight: 400"
                  >
                    {{ getIndonesianMonth(item.month) }} {{ item.year }}
                  </h3>
                </div>
              </v-sheet>
            </v-col>
            <v-col align="left" class="my-auto" cols="4">
              <v-sheet>
                <a
                  class="text-decoration-none"
                  style="color: #497bdd; font-size: 14px; font-weight: 400"
                  @click="onDownloadFile(item.file_url, item.file_name)"
                >
                  {{ item.file_name }}
                </a>
              </v-sheet>
            </v-col>
          </v-row>
          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </div>
    </div>

    <v-dialog v-model="dialogLog" max-width="500">
      <v-card class="px-10 py-10">
        <v-layout row wrap justify-space-between align-center>
          <h1 style="font-size: 1.5rem; font-weight: 700">Log Data</h1>
          <div class="container mt-10">
            <v-progress-circular
              v-show="loadingLog"
              color="primary"
              indeterminate
            ></v-progress-circular>

            <div v-if="!loadingLog">
              <vue-json-pretty :data="log.parameters" />
            </div>
          </div>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  components: {
    VueJsonPretty,
  },
  props: {
    start_date: {
      type: String,
      required: true,
    },
    end_date: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      snackbar: false,
      message: "",
      dialogLog: false,
      loadingLog: false,
      log: {},
    };
  },
  computed: {
    formattedGate() {
      return this.selectedGate.join(",");
    },
    fetchParams() {
      return {
        from: this.start_date,
        to: this.end_date,
      };
    },
  },
  watch: {
    fetchParams: {
      handler() {
        if (this.start_date && this.end_date) {
          this.fetchData();
        }
      },
      deep: true,
    },
  },
  methods: {
    getIndonesianMonth(monthNumber) {
      const indonesianMonths = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      // Convert month number to integer and subtract 1 for array index (0-based)
      const index = parseInt(monthNumber, 10) - 1;

      // Return the Indonesian month name or the original value if invalid
      return index >= 0 && index < 12 ? indonesianMonths[index] : monthNumber;
    },

    async fetchData() {
      try {
        const response = await this.$axios.get("/reconciles", {
          params: this.fetchParams,
        });
        // this.documents = mockFile.history.documents;
        this.documents = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async onShowLog(recordDate, gate, type) {
      this.dialogLog = true;
      this.loadingLog = true;

      try {
        const response = await this.$axios.get("document-histories-logs", {
          params: {
            record_date: recordDate,
            gate: gate,
            type: type,
          },
        });

        this.log = response.data;

        console.log(response);
        this.loadingLog = false;
      } catch (error) {
        this.loadingLog = false;
        console.error("Error fetching data:", error);
      }
    },

    async onDownloadFile(url, name) {
      try {
        const response = await this.$axios.get(url);
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
        this.message = "File downloaded successfully.";
      } catch (error) {
        this.message = error.response.data.message;
        this.snackbar = true;
      }
    },
  },
};
</script>
